import filterIncentivesByTags from './filterIncentivesByTags';

const NEW_AND_USED_CAR_PROGRAM_URLS = [
  'https://www.irs.gov/credits-deductions/credits-for-new-clean-vehicles-purchased-in-2023-or-after',
  'https://www.irs.gov/credits-deductions/used-clean-vehicle-credit',
];

// Our objective is return incentives in the same
// format as costs.
//
// The incentives come in a format given by the
// Rewiring America API.
//
// Costs are in a format defined by us.
//
// Additional considerations:
//
// 1. Some incentives need us to calculate the
//    final cost using the cost's price range.
// 2. Sometimes two or more incentives are
//    actually the same one, describing different
//    scenarios, and having different prices. In
//    that case we need to combine them and find
//    the min and max prices.
const convertIncentivesToCosts = (incentives, cost) => {
  const incentivesWithPriceRange = incentives.map((incentive) => ({
    ...incentive,
    price_range: [
      -calculateIncentivePrice(incentive.amount, cost.price_range[1]),
      -calculateIncentivePrice(incentive.amount, cost.price_range[0]),
    ],
  }));
  const combinedIncentives = combineIncentives(incentivesWithPriceRange);
  return combinedIncentives.map((incentive) => ({
    component_name: null,
    price_description:
      incentive.program.replace(/\(.*\)/, '') +
      (cost.incentive_helper ? ` (${cost.incentive_helper})` : ''),
    price_range: incentive.price_range,
    price_unit: 'usd',
  }));
};

const calculateIncentivePrice = (incentiveAmount, costPrice) => {
  return incentiveAmount.type == 'percent'
    ? costPrice * incentiveAmount.number
    : incentiveAmount.number;
};

// Some incentives are represented twice in the
// data, usually with different prices. This joins
// them, and finds the min and max prices
const combineIncentives = (incentives) => {
  let remaining = [...incentives];
  const consolidated = [];

  while (remaining.length > 0) {
    const incentiveA = remaining.shift();
    const sames = [
      incentiveA,
      ...remaining.filter((incentiveB) => sameIncentive(incentiveA, incentiveB)),
    ];
    remaining = remaining.filter((item) => !sames.includes(item));
    const mins = sames.map((item) => item.price_range[0]);
    const maxes = sames.map((item) => item.price_range[1]);
    consolidated.push({
      ...incentiveA,
      price_range: [Math.min(...mins), Math.max(...maxes)],
    });
  }

  return consolidated;
};

const sameIncentive = (a, b) => {
  // We treat the new-car and used-car incentives
  // that we know about as the same, because they
  // are mutually exclusive
  if (
    NEW_AND_USED_CAR_PROGRAM_URLS.includes(a.program_url) &&
    NEW_AND_USED_CAR_PROGRAM_URLS.includes(b.program_url)
  ) {
    return true;
  }
  // All other incentives are the same IFF the URL
  // and name are equal
  return a.program_url === b.program_url && a.program === b.program;
};

export default convertIncentivesToCosts;
